/**
 * Integration Account Component Renderer
 *
 * Renders integration account components with proper prop spreading and validation.
 *
 * @since 6.9.0 Initial implementation
 */
import { html } from 'lit';
import { spreadProps } from '../utils/spread-props';
/**
 * Allowed props for uo-integration-account component
 */
const uoIntegrationAccountAllowedProps = new Set([
    'username',
    'avatar',
    'integration',
    'variant',
    'message',
    'status',
    'loading'
]);
/**
 * Render integration account component
 *
 * @param {IntegrationAccountData} data - The account data to render
 * @param {ComponentProps} [props={}] - Additional props to spread
 *
 * @return {TemplateResult} The rendered integration account component
 */
export function accountRenderer(data, props = {}) {
    return html `
		<uo-integration-account ${spreadProps(uoIntegrationAccountAllowedProps)({ ...data, ...props })}></uo-integration-account>
	`;
}
